"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourcesReturningUuids = void 0;
const api_models_1 = require("@portal/api-models");
exports.resourcesReturningUuids = [
    api_models_1.RepositoryKey.Accounts,
    api_models_1.RepositoryKey.SubAccounts,
    api_models_1.RepositoryKey.Users,
];
